import Vue from 'vue'
import Vuex from 'vuex'
import { state } from './state'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

import AuthModule from '../components/auth/store'
import ApplicationServerModule from '../components/applicationServer/store'
import DashboardModule from '../components/dashboard/store'
import AccountModule from '../components/account/store'
import ThemeModule from '../components/theme/store'
import TemplateModule from '../components/template/store'
import UserModule from '../components/user/store'
import CustomerModule from '../components/customer/store'
import PluginModule from '../components/plugin/store'
import CollectionModule from '../components/collection/store'
import SnippetModule from '../components/snippet/store'
import SendunitModule from '../components/sendunit/store'
import SendunitPoolModule from '../components/sendunitPool/store'
import SendManager from '../components/sendManager/store'
import VariableModule from '../components/variable/store'
import MailingTemplateModule from '../components/mailingTemplate/store'
import MediaManager from '../components/mediaManager/store'
import LanguageModule from '../components/languages/store'
import BlacklistModule from '../components/blacklist/store'
import TriggerTypeModule from '../components/triggerType/store'
import SettingsModule from '../components/settings/store'
import ModuleModule from '../components/module/store'
import IDPUserModule from '../components/idpUser/store'
import StatisticModule from '../components/statistics/store'
import ExternalIDPModule from '../components/externalIDP/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth: AuthModule,
    applicationServer: ApplicationServerModule,
    dashboard: DashboardModule,
    accounts: AccountModule,
    themes: ThemeModule,
    templates: TemplateModule,
    users: UserModule,
    customers: CustomerModule,
    plugins: PluginModule,
    collections: CollectionModule,
    snippets: SnippetModule,
    sendunits: SendunitModule,
    sendunitPools: SendunitPoolModule,
    variables: VariableModule,
    mailingTemplates: MailingTemplateModule,
    mediaManager: MediaManager,
    languages: LanguageModule,
    blacklist: BlacklistModule,
    triggerTypes: TriggerTypeModule,
    settings: SettingsModule,
    module: ModuleModule,
    sendManager: SendManager,
    idpUsers: IDPUserModule,
    statistics: StatisticModule,
    externalIDP: ExternalIDPModule,
  },
  state,
  getters,
  actions,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js